import React from 'react';
import styles from '../sidebar.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faRectangleList,
    faDatabase,
    faBuildingColumns,
    faUsers,
    faGripVertical,
    faBuilding,
    faRightFromBracket,
    faCircleChevronLeft,
    faHeadphones
} from '@fortawesome/free-solid-svg-icons';
import { Link, NavLink, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import constant from '../../../../constant';

const menuItems = [
    {
        label: 'Dashboard',
        icon: faRectangleList,
        url: constant.component.dashboard.url,
    },
    {
        label: 'Database Search',
        icon: faDatabase,
        url: constant.component.databaseSearch.url,
    },
    {
        label: 'Campus Drive',
        icon: faBuildingColumns,
        url: constant.component.campusDriveDashboard.url,
    },
    {
        label: 'Manage Users',
        icon: faUsers,
        url: constant.component.UserList.url,
    },
    {
        label: 'Recruiter Guidelines',
        icon: faGripVertical,
        url: constant.component.RecruiterGuidelines.url,
    },
    {
        label: 'Commercial',
        icon: faBuilding,
        url: '#',
    },
];

const Index = ({ isSidebarCollapsed, setIsSidebarCollapsed }) => {

    const location = useLocation();

    const isActive = (url) => {
        if (url === '#') return false;
        return location.pathname === url;
    };

    return (
        <div className={`${styles.sidebarn} sidebarctm ${isSidebarCollapsed ? 'collapsed' : ''}`}>
            <div className="d-flex flex-column h-100 sidebar p-3">
                <ul className={`${styles['side-nav']} nav flex-column`}>
                    {menuItems.map((item, index) => (
                        <li className={`nav-item mb-3 
                  ${isActive(item.url) ? 'active' : ''}
                        `} key={index}>
                            <Link
                                to={item.url}
                                className={`
                  ${styles['navc-link']}
                  nav-link
                  d-flex
                  align-items-center
                `}
                            >
                                <FontAwesomeIcon className="pe-2" icon={item.icon} />
                                {!isSidebarCollapsed && <span>{item.label}</span>}
                            </Link>
                        </li>
                    ))}

                    <li className="nav-item">
                        <NavLink
                            to={constant.component.logout.url}
                            className={`${styles['navc-link']} nav-link d-flex align-items-center`}
                        >
                            <FontAwesomeIcon className="pe-2" icon={faRightFromBracket} />
                            {!isSidebarCollapsed && <span>Logout</span>}
                        </NavLink>
                    </li>
                </ul>

                {!isSidebarCollapsed && (
                    <div className="mt-auto text-center">
                        <div className="d-flex bg-white align-items-center justify-content-center rounded-2">
                            <FontAwesomeIcon icon={faHeadphones} className={`${styles['headphone-icon']} pe-2`} />
                            <div className="text-start">
                                <p className={`${styles['phone-num']} mb-0`}>+91-7353-466-466</p>
                                <p className={`${styles['headphone-text']}`}>Indian Sales Support</p>
                            </div>
                        </div>
                        <p className="mt-2 text-muted fs-7">© 2023 JobzShala.com Powered by AIPL</p>
                    </div>
                )}
            </div>

            <button
                onClick={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
                className={styles['toggle-btn']}
            >
                <FontAwesomeIcon className={styles['toggle-icon']} icon={faCircleChevronLeft} />
            </button>
        </div>
    );
};

export default Index;
